/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// Authority management

// Get list
export function authPermissionRuleList(query) {
    return axios({
        url: "/admin/auth/permission_rule/index",
        method: "get",
        params: query
    });
}

// save
export function authPermissionRuleSave(data, formName, method = "post") {
    let url =
        formName !== "Edit" ?
        "/admin/auth/permission_rule/save" :
        "/admin/auth/permission_rule/edit";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// delete
export function authPermissionRuleDelete(data) {
    return axios({
        url: "/admin/auth/permission_rule/delete",
        method: "post",
        data: data
    });
}